module.exports = "pegasus/assets/email1-company-logo3.png";